import overviewInactive from "../../../assets/overview-inactive.png";
import overviewActive from "../../../assets/overview-active.png";

import inventoryInactive from "../../../assets/box-inactive.png";
import inventoryActive from "../../../assets/inventoryActive.png";
import salesReportActive from "../../../assets/chart-active.png";

import salesReportInactive from "../../../assets/chart-inactive.png";
import walletInactive from "../../../assets/wallet-inactive.png";
import walletActive from "../../../assets/wallet-2.png";
import profileInactive from "../../../assets/profile-inactive.png";
import profileActive from "../../../assets/profile-active.png"

const navData = [
  {
    name: "Overview",
    route: "/seller-overview",
    iconActive: overviewActive,
    iconInactive: overviewInactive,
  },

  {
    name: "Inventory Manager",
    route: "/seller-inventory",
    iconActive: inventoryActive,
    iconInactive: inventoryInactive,
  },

  {
    name: "Sales Report",
    route: "/seller-sales",
    iconActive: salesReportActive,
    iconInactive: salesReportInactive,
  },

  {
    name: "Wallet",
    route: "/seller-wallet",
    iconActive: walletActive,
    iconInactive: walletInactive,
  },

  {
    name: "Profile",
    route: "/seller-profile",
    iconActive: profileActive,
    iconInactive: profileInactive,
  },
];

export default navData;
